import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-welltect-register',
  templateUrl: './welltect-register.component.html',
  styleUrls: ['../style/global.css', './welltect-register.component.css'],
})
export class WelltectRegisterComponent
  extends BaseLoginComponent
  implements OnInit
{
  public acceptTerm = false;
  public acceptPrivacyPolicy = false;
  isRegistable = true;
  public initialized: boolean = true;

  async init(): Promise<void> {}

  registrationRole(): string {
    return undefined;
  }

  get baseLink() {
    return environment.apps[this.clientId].appUrl;
  }

  get isOem() {
    return /oem/g.test(environment.apps[this.clientId].type);
  }

  get oemId() {
    return environment.apps[this.clientId].oemConfig?.id;
  }

  get privacyUrl() {
    return environment.apps[this.clientId].privacyUrl;
  }

  get termsUrl() {
    return environment.apps[this.clientId].termUrl;
  }

  get appname() {
    return environment.apps[this.clientId].oemConfig?.name || 'Doctors Station';
  }
}
